import React from 'react';
import { useSelector } from 'react-redux';
import { labelsSelector } from 'src/redux/app/selectors';

const useLabel = () => {
  const labels = useSelector(labelsSelector);

  const getLabel = (labelName, fallback) => labels[labelName] || fallback || labelName;

  return getLabel;
};

export default useLabel;
